import { render, staticRenderFns } from "./UserGroupCoursesTableActions.vue?vue&type=template&id=64c37884&"
import script from "./UserGroupCoursesTableActions.vue?vue&type=script&lang=js&"
export * from "./UserGroupCoursesTableActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports